export const API_ENDPOINTS = {
    SALESPERSON: {
        GET_SALESPERSON_BY_ID: "SalesPerson/GetById",
        SEARCH_SALESPERSON: "SalesPerson/Search",
        EXPORT_SALESPERSON: "SalesPerson/Export",
        SAVE_SALESPERSON: "/SalesPerson/Save",
        UPDATE_SALESPERSON: "/SalesPerson/Update",
        DELETE_SALESPERSON: "SalesPerson/Delete",

  },
 
  // Add other modules like EMPLOYEE, DEPARTMENT etc.
};

export const QUERY_KEYS = {
    SALESPERSON: {
        SALESPERSON: ["SalesPersonSearch"], // UNIQUE IN OVER ALL APPLICATION
  },
  
};